<template>
<div class="chapter">
<div class="inner_page">
<p class="epi" id="epi"><a id="pVI"></a><a id="pVII"></a><i>“It is difficult to get a man to understand something, <br/>when his salary depends upon his not understanding it!”</i></p>
<p class="epis"><i>Upton Sinclair</i>, I, Candidate for Governor: And How I Got Licked</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?59f38d37